export default __webpack_public_path__ + "static/media/sites-mob2.b8314565.png";